import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import DynamicPropertyDropdown from 'components/UI/DynamicPropertyDropdown/DynamicPropertyDropdown';
import DrawerLayout from 'components/Views/Creative/Drawers/DrawerLayout';
import store from 'stores/RootStore';
import { PanelViews } from 'types/PanelViews';

import FiltersDrawerHeader from './FiltersDrawerHeader';
import NewFilterSetModal from './NewFilterSetModal';

const PropertiesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 20px 24px;
`;

function FiltersDrawer() {
  const store_creative = store.creative;
  if (!store_creative) return null;

  const handleOnClose = () => {
    store_creative.setPanel(PanelViews.NONE);
  };

  // Hoisted because the map below reaches for it once per name. `all` is a
  // plain field rather than a getter, so this is not about recomputation - it
  // is so the scan inside the loop is visible as what it is: every property
  // checked against every name.
  const allFilterProperties = store_creative.ads.filter.available;
  const availableProperties = allFilterProperties.getAllPropertiesNames();

  return (
    <>
      <DrawerLayout
        open={store_creative.displayPanel === PanelViews.FILTER}
        onClose={handleOnClose}
        title={<FiltersDrawerHeader />}
      >
        <PropertiesContainer>
          {availableProperties.map((propertyName) => (
            <DynamicPropertyDropdown
              key={propertyName}
              name={propertyName}
              values={allFilterProperties.properties.filter(
                (prop) => prop.name === propertyName && prop.label && prop.value
              )}
            />
          ))}
        </PropertiesContainer>
      </DrawerLayout>

      <NewFilterSetModal />
    </>
  );
}

export default observer(FiltersDrawer);
